// @ts-nocheck
import { httpClient } from '../../../core/network';

class TracerService {
  static clearTracers(userId, tracers) {
    const traceServices = {
      traceServices: tracers.map(tracer => tracer.traceService),
    };
    const apiUrl = `/auth0/users/${userId}/trace-ids`;
    return httpClient.put(apiUrl, { traceServices });
  }
}

export default TracerService;
